import React, { useEffect, useState } from 'react';

export default function ScoreRing({ score }) {
  const [offset, setOffset] = useState(276.5);
  const circumference = 276.5;
  const color = score >= 70 ? '#00ffe7' : score >= 45 ? '#f0a500' : '#ff3c6e';

  useEffect(() => {
    const timer = setTimeout(() => { setOffset(circumference * (1 - score / 100)); }, 100);
    return () => clearTimeout(timer);
  }, [score]);

  return (
    <div style={{ textAlign: 'center', flexShrink: 0 }}>
      <div style={{ position: 'relative', width: '110px', height: '110px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
        <svg viewBox="0 0 100 100" style={{ position: 'absolute', inset: 0, transform: 'rotate(-90deg)' }}>
          <circle cx="50" cy="50" r="44" stroke="rgba(0,255,231,0.12)" strokeWidth="6" fill="none" />
          <circle cx="50" cy="50" r="44" stroke={color} strokeWidth="6" fill="none" strokeLinecap="round"
            strokeDasharray={circumference} strokeDashoffset={offset}
            style={{ transition: 'stroke-dashoffset 1.2s cubic-bezier(0.4,0,0.2,1), stroke 0.3s' }} />
        </svg>
        <div style={{ fontFamily: 'var(--font-head)', fontSize: '30px', fontWeight: 900, color, position: 'relative', zIndex: 1 }}>{score}</div>
        <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', color: 'var(--text2)', position: 'relative', zIndex: 1 }}>/100</div>
      </div>
      <div style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', color: 'var(--neon)', letterSpacing: '0.15em', marginTop: '8px' }}>INTEL SCORE</div>
    </div>
  );
}
